(function (window, document) {
	'use strict';

	function ready(callback) {
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', callback);
		} else {
			callback();
		}
	}

	ready(function () {
		const consent = window.CareerDeskCookieConsent;
		const banner = document.querySelector('[data-cookie-consent]');
		if (!consent || !banner) return;

		const accept = banner.querySelector('[data-cookie-accept]');
		const reject = banner.querySelector('[data-cookie-reject]');

		function showBanner() {
			banner.hidden = false;
			document.documentElement.classList.add('cookie-consent-open');
			window.requestAnimationFrame(function () {
				banner.classList.add('is-visible');
				(accept || reject).focus();
			});
		}

		function hideBanner() {
			banner.classList.remove('is-visible');
			document.documentElement.classList.remove('cookie-consent-open');
			window.setTimeout(function () {
				banner.hidden = true;
			}, 200);
		}

		accept.addEventListener('click', function () {
			consent.set('accepted');
			hideBanner();
		});

		reject.addEventListener('click', function () {
			consent.set('rejected');
			hideBanner();
		});

		document.addEventListener('careerdesk:cookie-consent-open', showBanner);

		if (!consent.get()) {
			showBanner();
		}
	});
})(window, document);
